import {Vector} from 'ol/layer.js';
import {Vector as VectorSource} from 'ol/source.js';
import {Style, Fill, Stroke, Text, Icon} from 'ol/style.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import Select from 'ol/interaction/Select.js';
import {click} from 'ol/events/condition.js';
import {Layer} from './Layer.js';
import Library from './Library.js';

export class GeoJsonLayer extends Layer{
    api_endpt = "";
    icon_path = "";
    api_path = "";
    date = "now";
    resolution = null;

    constructor( map, settings = {} ){
        if( settings['opacity'] == undefined ) settings['opacity'] = 1;
        super( map, settings );
        if( settings.api_endpt ){ this.api_endpt = settings.api_endpt; delete this.settings['api_endpt']; }
        this.getState();

        this.class = "geojson";
        this.icon_path = this.map.server + "/cgi-bin/plot";
        this.api_path = this.map.server + "/cgi-bin/json";

        this.source = new VectorSource({
                "url": this.getUrl.bind(this),
                "strategy": this.strategy.bind(this),
                "format": new GeoJSON(),
                }),
        this.layer = new Vector({
                "source": this.source,
                "style": (f,r) => { return this.getStyle( f, r )},
                "visible": this.settings['visible']
                });

        this.layer.set('name', this.name);

        this.source.on( "featuresloadstart", this.map.loadingStart.bind(this.map) );
        this.source.on( "featuresloadend", this.map.loadingEnd.bind(this.map));
            
        //this.select = new Select({
                //"condition": click,
                //"style": this.getSelectStyle.bind(this)
                //});
        //this.map.map.addInteraction(this.select);
    }

    getUrl( extent, resolution, projection ){
        return this.map.server + this.api_path + "/" + this.api_endpt;
    }

    getColor( feature ){
        return "#800000";
    }

    getLineColor(feature){
        return "#800000";
    }

    getFillColor(feature){
        return "#800000";
    }

    getHighlightColor(feature){
        return "#FFFFFF";
    }

    getLabel( feature ){
        return "label";
    }

    getOpacity(feature){
        return this.settings['opacity'];
    }

    getStyle(feature, resolution ){
        let style = new Style({
            "image": new Icon({
                    "src": "/images/flame-icon.gif",
                    "height": 24,
                    "width": 24
                    }),
            "fill": new Fill({
                    "color": this.getFillColor(feature)
                    }),
            "stroke": new Stroke({
                    "color": this.getLineColor(feature),
                    "width": 2
                    }),
            "text": new Text({
                    "font": "12px",
                    "fill": new Fill({
                            "color": '#000',
                            }),
                    "text": this.getLabel(feature),
                    "stroke": new Stroke({"color": "white", "width": 2 })
                    })
    
                });
        return style;
    }

    getSelectStyle(feature){
        let orig_style = feature.getStyle();
        let style = new Style({
                "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getHighlightColor(feature), 
                                this.settings['opacity'])
                        }),
                "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getLineColor(feature)),
                        "width": 2
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray("#800000")
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 })
                        })

                });
        return style;
    }

    popupTitle( title, desc ){
        return "<div style='font-size:10px; color: black'>" +
            "<div style='background-color: #3350ff; color: white; font-weight: bold'>" +
            title + ": " + desc + "</div>";
    }

    popupSep(){
        return "<hr style='margin:1px 0 1px 0'/>";
    }

    popupData( title, data, data_color ){
        if( data_color == undefined ) data_color = "black";
        if( title == "" || title == undefined )
            return "<span style='color: " + data_color + "'>" + 
                data + "</span><br/>";
        return "<span style='color: #7777CC; font-weight: bold'>" +
            title + ": </span><span style='color: " + data_color + "'>" + 
            data + "</span><br/>";
    }

    popupEnd(){
        return "</div>";
    }

    property( feature, key ){
        return feature.get(key);
    }

    refresh( ){
        console.info( 'refreshing geojson', this.name );
        this.layer.getSource().refresh();
    }

    set( key, val ){
        if( key in this.settings ){
            super.set( key, val );
            this.refresh();
            return 1;
        }
        return 0;
    }

    strategy(extent, resolution){
        if(this.resolution && this.resolution != resolution){
            this.refresh();
        }
        this.resolution = resolution;
        return [extent];
    }
}
